import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_11_SIGN_UP_FACEPILES_SUBTITLE_250708 } from "@faire/retailer-settings/FE_BATCH_11_SIGN_UP_FACEPILES_SUBTITLE_250708";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";

export const useSettingBatch11SignUpFacePiles = (): IThreeVariantXP.Bucket =>
  useSetting(FE_BATCH_11_SIGN_UP_FACEPILES_SUBTITLE_250708);

export const useAssignSettingBatch11SignUpFacePiles = () =>
  useAssignSetting(FE_BATCH_11_SIGN_UP_FACEPILES_SUBTITLE_250708);
